import { createSelector } from '@ngrx/store'

export const getUnitsSettingsState = createSelector(
  (state: any) => state.unitsSettings,
  (state: any) => state,
)
